import React, { Component } from 'react'
import PageHeaderSection from '../components/sections/PageHeaderSection'
import BlogCard from '../components/cards/BlogCard'
import { configRedux } from '../redux/ConfigRedux'
import { getBlogs } from '../actions/MainAction'
import { Helmet } from 'react-helmet'

export class BlogPage extends Component {
  componentDidMount(){
    this.props.dispatch(getBlogs());
    window.scrollTo(0, 0);
  }
  render() {
    const {blogs} = this.props;

    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>Nicode Academy Blog - Data Analitika, Data Science və Texnologiya Məqalələri</title>
          <meta name="description" content="Nicode Academy blogunda Data Analitika, Data Science, Python, Excel, SQL və digər texnologiyalar haqqında faydalı məqalələr oxuyun. Son yeniliklər, tədris məsləhətləri və peşəkar bacarıqlarınızı inkişaf etdirmək üçün tövsiyələr əldə edin."/>
          <meta property="og:type" content="website" /> 
          <meta name="robots" content="all, index" /> 
          <meta property="og:description" content="Nicode Academy blogunda Data Analitika, Data Science, Python, Excel, SQL və digər texnologiyalar haqqında faydalı məqalələr oxuyun. Son yeniliklər, tədris məsləhətləri və peşəkar bacarıqlarınızı inkişaf etdirmək üçün tövsiyələr əldə edin."/>
          <meta name="keywords" content="Nicode Academy blog, Data Science məqalələri, Data Analitika bloqu, Python tədris məsləhətləri, SQL və Excel bloqu, texnologiya bloqu, Power BI təlim məqalələri, rəqəmsal tədris bloqu" />
          <link rel="canonical" href="https://nicode.az/blog"/>
          <meta property="og:locale" content="az_AZ"/>
          <meta property="og:type" content="Nicode Academy Blog - Data Analitika, Data Science və Texnologiya Məqalələri"/>
          <meta property="og:title" content="Nicode Academy Blog - Data Analitika, Data Science və Texnologiya Məqalələri"/>
          <meta property="og:url" content="https://nicode.az/blog"/>
          <meta property="og:site_name" content="https://nicode.az/blog"/>
          <meta property="og:image" content="https://nicode.az/static/media/nicode2.65d12d39210d7ec2788e.png"/>
          <meta property="og:image:secure_url" content="https://nicode.az/static/media/nicode2.65d12d39210d7ec2788e.png"/>

          <meta name="twitter:site" content="nicode.az"/>
          <meta property="og:url" content="http://nicode.az"/>
          <meta property="og:title" content="Nicode Academy Blog - Data Analitika, Data Science və Texnologiya Məqalələri"/>
          <meta property="og:description" content="Nicode Academy blogunda Data Analitika, Data Science, Python, Excel, SQL və digər texnologiyalar haqqında faydalı məqalələr oxuyun. Son yeniliklər, tədris məsləhətləri və peşəkar bacarıqlarınızı inkişaf etdirmək üçün tövsiyələr əldə edin."/>
        </Helmet>
        <PageHeaderSection title={'Bloqlarımız'} />
        <section className='mt-5'>
          <div className='container flex column gap-20'>
            {
              blogs.map((data, i)=>{
                return(
                  <BlogCard 
                    key={i}
                    data={data}
                  />
                )
              })
            }
          </div>
        </section>
      </div>
    )
  }
}

export default configRedux(BlogPage, ["blogs"])